<div class="legend" [attr.aria-label]="'label.aria.chartLegend' | translate | async">
  <div class="category" *ngFor="let category of categories">
      <app-legend-marker  [type]="category.type" [color]="category.color"></app-legend-marker>
      {{category.label}}
  </div>
  <ng-content select="[legend-action]"></ng-content>
</div>
